import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import { useLoadCabinet } from './api'
import type { CabinetMainType } from './types'
import type { StatusType } from '@/shared/ui'
import { DateTime } from 'ts-luxon'
import {
  getElParamsStatuses,
  getMainStatuses,
  getMeterStatuses,
  getPinStatuses,
} from '@/entities/Cabinet'

export const useCabinetMain = defineStore('cabinet_main', () => {
  const cabinet = ref<CabinetMainType | null>(null)

  /**
   * Функция загрузки данных о шкафе
   */
  const loadCabinetMainData = () => {
    const result = useLoadCabinet()

    watch(result.data, () => {
      if (result.data.value) cabinet.value = result.data.value.data
    })

    return result
  }

  /* Вычисляем статусы для шкафа */
  const statuses = computed<StatusType[]>(() => {
    if (!cabinet.value) return []

    return [
      ...getMainStatuses(cabinet.value),
      ...getPinStatuses(cabinet.value),
      ...getMeterStatuses(cabinet.value),
      ...getElParamsStatuses(cabinet.value),
    ]
  })

  /* Вычисляем даты статусов */
  const statusesDate = computed(() => {
    let last = ''
    let error = ''

    if (cabinet.value) {
      if (cabinet.value.pin_statuses[0]) {
        const timestamp = new Date(cabinet.value.pin_statuses[0].event_time)
        last = DateTime.fromJSDate(timestamp).toFormat('dd.LL.yyyy HH:mm:ss')
      }
    }

    return {
      last,
      error,
    }
  })

  return {
    cabinet,
    statuses,
    statusesDate,

    loadCabinetMainData,
  }
})
